import {
  DocumentOrganizationKeys,
  FilterOptionKeys,
  Goal,
  GoalFilterDocument,
  GoalSortingMode,
  GroupByMode,
  LifeArea,
  LocalizedLifeArea,
} from '@griply/types';

export const getLifeAreaGoalFilterDocument = (
  lifeArea: LifeArea | LocalizedLifeArea | undefined,
  goals: Goal[],
): GoalFilterDocument => {
  const base: GoalFilterDocument = lifeArea?.goalFilterDocument ?? {
    [DocumentOrganizationKeys.GroupByMode]: GroupByMode.None,
  };

  // Goal grouping was offered here once; the roadmap lists the goals themselves, so it has no meaning.
  const groupByMode =
    base.groupByMode === GroupByMode.Goal
      ? GroupByMode.None
      : base.groupByMode ?? GroupByMode.None;

  return {
    ...base,
    [DocumentOrganizationKeys.GroupByMode]: groupByMode,
    [DocumentOrganizationKeys.SortingMode]:
      base.sortingMode ??
      lifeArea?.goalSortingMode ??
      GoalSortingMode.StartDate,
    [DocumentOrganizationKeys.Filters]: {
      ...(base[DocumentOrganizationKeys.Filters] ?? {}),
      [FilterOptionKeys.LifeArea]: {
        include: [lifeArea?.id ?? ''],
      },
    },
    [DocumentOrganizationKeys.CollapsedSections]:
      base.collapsedSections ??
      lifeArea?.collapsedGoals ??
      goals.map(({ id }) => id),
  };
};
